import React from 'react';
import { isAuthenticated } from '../../utils/auth';
import { Redirect, Route } from 'react-router-dom';

function PrivateRoute({ condition = true, component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() === condition ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: props.location }
            }}
          />
        )}
    />
  );
}

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/containers/PrivateRoute/index.js